//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const PdfEditor: FeatureFlag = {"Id":"PdfEditor","Label":"PDF \"Editor\"","Impact":"Allows adding PDF-only pages to a form that are useable for Generated PDF activities","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
